import { Component }      from 'react';
import { browserHistory } from 'react-router';

class PlaceItem extends Component
{

    getPlaceSlug = (place) =>
    {
        if (place.slug.length > 0)
        {
            return place.slug;
        }

        return place.id;
    };

    onPlaceSelected = (place) =>
    {
        browserHistory.push('/place/' + this.getPlaceSlug(place));
    };

    onTrailSelected = (place) =>
    {
        browserHistory.push('/place-map/' + this.getPlaceSlug(place));
    };

    resolveMainImage = (place) =>
    {
        const resolveAltText = (image, fallback) => {
            if (image.hasOwnProperty('altText') && String(image.altText).length > 0) {
                return image.altText;
            }

            return fallback
        }

        if ('trail' === place.type)
        {
            return {
                url: place.image,
                altText: resolveAltText(place, place.name),
            }
        }
        else
        {
            if (place.images.length > 0)
            {
                return {
                    url: place.images[0].url,
                    altText: resolveAltText(place.images[0], place.name)
                }
            }
        }

        return null;
    };

    resolveIntro = (place) =>
    {
        return ('trail' === place.type) ? place.summary : place.intro;
    };

    resolveClickEvent = (place) =>
    {
        return ('trail' === place.type) ? this.onTrailSelected : this.onPlaceSelected;
    };

}

PlaceItem.defaultProps = {
    distanceText: ' away'
};

export default PlaceItem




// WEBPACK FOOTER //
// ./src/components/PlaceItem.js